import * as yup from 'yup'

const isNullOrUndefined = function (value) {
  return value === null || value === undefined
}

export const passwordErrors = {
  LOWER_CHARACTER: 'One lower-case character',
  UPPER_CHARACTER: 'One upper-case character',
  DIGIT: 'One digit',
  SPECIAL_CHARACTER: 'One special character',
  MIN_LENGTH: '8 characters minimum'
}

export const formErrors = {
  INVALID_EMAIL: 'Please enter a valid email address',
  REQUIRED: 'This field cannot be empty',
  CONFIRM_EMAIL: 'Emails do not match',
  MIN_2: 'Field must be at least 2 characters'
}

export const passwordValidators = {
  DIGIT: (value) =>
    isNullOrUndefined(value) || (value.match(/[0-9]/g) || []).length >= 1,
  LOWER_CHARACTER: (value) =>
    isNullOrUndefined(value) || (value.match(/[a-z]/g) || []).length >= 1,
  UPPER_CHARACTER: (value) =>
    isNullOrUndefined(value) || (value.match(/[A-Z]/g) || []).length >= 1,
  SPECIAL_CHARACTER: (value) =>
    isNullOrUndefined(value) ||
    (value.match(/[^a-zA-Z0-9\s]/g) || []).length >= 1
}
const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ'’-]+$/

export const B2CSignUpFormSchema = yup.object({
  firstName: yup
    .string()
    .required(formErrors.REQUIRED)
    .min(2, formErrors.MIN_2)
    .matches(
      nameRegex,
      'First name cannot contain special characters or numbers'
    ),
  lastName: yup
    .string()
    .required(formErrors.REQUIRED)
    .min(2, formErrors.MIN_2)
    .matches(
      nameRegex,
      'Last name cannot contain special characters or numbers'
    ),
  email: yup
    .string()
    .email(formErrors.INVALID_EMAIL)
    .required(formErrors.REQUIRED),
  confirmEmail: yup
    .string()
    .email(formErrors.INVALID_EMAIL)
    .required(formErrors.REQUIRED)
    .oneOf([yup.ref('email'), null], formErrors.CONFIRM_EMAIL),
  acceptTerms: yup.bool().isTrue(),
  password: yup
    .string()
    .required(formErrors.REQUIRED)
    .min(8, formErrors.MIN_LENGTH)
    .test({
      name: 'lower-character',
      message: passwordErrors.LOWER_CHARACTER,
      test (value) {
        return passwordValidators.LOWER_CHARACTER(value)
      }
    })
    .test({
      name: 'upper-case',
      message: passwordErrors.UPPER_CHARACTER,
      test (value) {
        return passwordValidators.UPPER_CHARACTER(value)
      }
    })
    .test({
      name: 'special-character',
      message: passwordErrors.SPECIAL_CHARACTER,
      test (value) {
        return passwordValidators.SPECIAL_CHARACTER(value)
      }
    })
    .test({
      name: 'digit',
      message: passwordErrors.DIGIT,
      test (value) {
        return passwordValidators.DIGIT(value)
      }
    })
})

export const B2CSignUpFormPaymentSchema = yup.object({
  country: yup.string().required(),
  address1: yup.string().required(),
  city: yup.string().required(),
  state: yup.string().required(),
  postcode: yup.string().required()
})
